<template>
    <div>
        <img v-if="this.$i18n.locale == 'ar'" class="imgs" src="../../assets/mes_ar.png" alt="">
        <img v-else class="imgs" src="../../assets/mes_en.png" alt="">
    </div>
</template>
<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            userInfo: [],
        };
    },
    created() {
        this.$completes.complete("getUserInfo");
        window.getUserInfo = this.getUserInfo
        window['getUserInfo'] = (data) => {
            this.getUserInfo(data);
        }
    },
    mounted() {
    },
    methods: {
        getUserInfo(data) {
            this.userInfo = JSON.parse(data);
            let langs = this.userInfo.lang.substring(0, 2)
            let lang = this.userInfo.lang
            if (langs == 'zh') {
                if (lang == 'zh_TW' || lang == 'zh_HK') {
                    this.$i18n.locale = 'tc'
                }
                else {
                    this.$i18n.locale = 'zh'
                }
            }
            else if (langs == 'en') {
                this.$i18n.locale = 'en'
            }
            else if (langs == 'ar') {
                this.$i18n.locale = 'ar'
            }
            else {
                this.$i18n.locale = 'en'
            }
            document.title = this.$t('officialMember')
            document.querySelector('html').setAttribute('lang', this.$i18n.locale);
        }

    },
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
}
</style>